import { Rarity } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useEnableSetFeatures } from '#src/hooks/commonGame/useEnableSetFeatures.ts';
import { useSeriesNav } from '#src/hooks/commonGame/useSeriesNav.ts';
import { useLifecycle } from '#src/hooks/useLifecycle.ts';

export const useFilteredShardsChests = () => {
  const { currentUser } = useCurrentUserContext();
  const { lifecycle } = useLifecycle();
  const seriesNav = useSeriesNav();
  const enableSetFeatures = useEnableSetFeatures();
  const { cardShardsChests } = currentUser || {};

  return cardShardsChests?.filter(shard => {
    if (shard.rarity === Rarity.common) {
      return !lifecycle?.hideCommonFeatures && enableSetFeatures;
    }
    if (seriesNav) {
      return shard.cardSet?.slug === 'winter';
    }
    return true;
  });
};
